import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, Menu, X, Wallet, Film } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/galleria", label: "Galleria" },
  { to: "/preventivo", label: "Preventivo" },
  { to: "/stato", label: "Stato" },
  { to: "/recensioni", label: "Recensioni" },
  { to: "/contatti", label: "Contatti" },
  { to: "/promozioni", label: "Promozioni" },
  { to: "/richiesta", label: "Richiedi" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full bg-black/60 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" onClick={() => setOpen(false)} className="flex items-center gap-2.5 group shrink-0">
          <img src="/logo-web.png" alt="AC Creator 3D" className="h-11 w-auto animate-logo" />
          <span className="sr-only">AC Creator 3D</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-4 py-2 text-sm font-medium transition-colors duration-200 rounded-sm ${
                pathname === l.to ? "text-neon-cyan" : "text-muted-foreground hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Button data-testid="nav-video-btn" onClick={() => navigate("/admin/video")} variant="ghost" className="hidden sm:flex text-neon-pink hover:text-neon-pink hover:bg-neon-pink/10 gap-2">
                <Film className="w-4 h-4" /> <span className="hidden lg:inline">Video</span>
              </Button>
              <Button data-testid="nav-finance-btn" onClick={() => navigate("/admin/finanze")} variant="ghost" className="hidden sm:flex text-neon-cyan hover:text-neon-cyan hover:bg-neon-cyan/10 gap-2">
                <Wallet className="w-4 h-4" /> <span className="hidden lg:inline">Finanze</span>
              </Button>
              <Button data-testid="nav-dashboard-btn" onClick={() => navigate("/admin")} variant="ghost" className="hidden sm:flex text-neon-green hover:text-neon-green hover:bg-neon-green/10 gap-2">
                <LayoutDashboard className="w-4 h-4" /> <span className="hidden lg:inline">Dashboard</span>
              </Button>
              <Button data-testid="nav-logout-btn" onClick={() => { logout(); navigate("/"); }} variant="ghost" className="hidden sm:flex text-muted-foreground hover:text-neon-pink">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <Button data-testid="nav-login-btn" onClick={() => navigate("/login")} className="hidden sm:flex bg-neon-cyan text-black hover:bg-white rounded-sm font-semibold transition-colors duration-200">
              Accedi
            </Button>
          )}
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} aria-label="Menu" className="md:hidden w-10 h-10 flex items-center justify-center rounded-sm border border-white/15 text-white hover:border-neon-cyan hover:text-neon-cyan transition-colors duration-200">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/10 px-5 py-4 flex flex-col gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-m-${l.label.toLowerCase()}`}
              className={`px-4 py-3 text-base font-medium rounded-sm ${pathname === l.to ? "text-neon-cyan bg-neon-cyan/5" : "text-muted-foreground"}`}
            >
              {l.label}
            </Link>
          ))}
          <div className="border-t border-white/10 mt-2 pt-2 flex flex-col gap-1">
            {user ? (
              <>
                <button data-testid="nav-m-video" onClick={() => { setOpen(false); navigate("/admin/video"); }} className="text-left px-4 py-3 text-base text-neon-pink rounded-sm">Video</button>
                <button data-testid="nav-m-finance" onClick={() => { setOpen(false); navigate("/admin/finanze"); }} className="text-left px-4 py-3 text-base text-neon-cyan rounded-sm">Finanze</button>
                <button data-testid="nav-m-dashboard" onClick={() => { setOpen(false); navigate("/admin"); }} className="text-left px-4 py-3 text-base text-neon-green rounded-sm">Dashboard</button>
                <button data-testid="nav-m-logout" onClick={() => { setOpen(false); logout(); navigate("/"); }} className="text-left px-4 py-3 text-base text-neon-pink rounded-sm">Esci</button>
              </>
            ) : (
              <button data-testid="nav-m-login" onClick={() => { setOpen(false); navigate("/login"); }} className="text-left px-4 py-3 text-base text-neon-cyan rounded-sm">Accedi</button>
            )}
          </div>
        </nav>
      )}
    </header>
  );
};
